"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Facebook, Instagram, Twitter, Linkedin } from "lucide-react";
const paymentMethods = [{
  id: "visa",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/partner_hgtv.png",
  alt: "HGTV"
}, {
  id: "mastercard",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/partner_diy.png",
  alt: "DIY Network"
}, {
  id: "jcb",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/partner_pool.png",
  alt: "Pool & Spa"
}, {
  id: "amex",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/partner_builder.png",
  alt: "Professional Builder"
}, {
  id: "paypal",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/partner_landscape.png",
  alt: "Landscape Management"
}, {
  id: "shopeepay",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/partner_masonry.png",
  alt: "Masonry Magazine"
}];
const socialLinks = [{
  id: "facebook",
  icon: Facebook,
  label: "Facebook",
  href: "#"
}, {
  id: "instagram",
  icon: Instagram,
  label: "Instagram",
  href: "#"
}, {
  id: "twitter",
  icon: Twitter,
  label: "Twitter",
  href: "#"
}, {
  id: "linkedin",
  icon: Linkedin,
  label: "LinkedIn",
  href: "#"
}];
const countries = ["United States", "Canada", "United Kingdom", "Australia", "New Zealand", "Germany", "France", "Spain", "Italy", "Mexico", "Brazil"];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8">
        {[1, 2].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
            <div className="flex flex-col gap-2">
              {[1, 2, 3, 4, 5].map((_, j) => <div key={j} data-index={j} className="h-3 w-32 bg-muted/50 animate-pulse rounded-md" />)}
            </div>
          </div>)}
      </div>;
  }
  const columns = menuItems.filter(item => item.children && item.children.length > 0);
  if (columns.length > 0) {
    return <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8">
        {columns.slice(0, 2).map((col, i) => <div key={col.id} data-index={i} className="flex flex-col gap-4">
            <h3 className="font-default font-semibold text-foreground uppercase tracking-wider text-xs">
              {col.label}
            </h3>
            <ul className="flex flex-col gap-2.5">
              {col.children?.map((child, j) => <li key={child.id} data-index={j}>
                  <Link to={child.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-xs">
                    {child.label}
                  </Link>
                </li>)}
            </ul>
          </div>)}
      </div>;
  }
  const mid = Math.ceil(menuItems.length / 2);
  const col1 = menuItems.slice(0, mid);
  const col2 = menuItems.slice(mid);
  return <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8">
      <div className="flex flex-col gap-4">
        <h3 className="font-default font-semibold text-foreground uppercase tracking-wider text-xs">
          Solutions
        </h3>
        <ul className="flex flex-col gap-2.5">
          {col1.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-xs">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>
      <div className="flex flex-col gap-4">
        <h3 className="font-default font-semibold text-foreground uppercase tracking-wider text-xs">
          Support
        </h3>
        <ul className="flex flex-col gap-2.5">
          {col2.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-xs">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>
    </div>;
}
export default function Footer() {
  return <footer data-section-id="264741" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t-4 border-primary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-12 mb-12">
          
          {}
          <MenuProvider menu_id="47">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default font-semibold text-foreground uppercase tracking-wider text-xs">
              Industry Partners
            </h3>
            <div className="grid grid-cols-3 gap-2">
              {paymentMethods.map((method, i) => <div key={method.id} data-index={i} className="bg-muted border border-border rounded-md p-1.5 flex items-center justify-center h-8 shadow-sm">
                  <img src={method.src} alt={method.alt} data-wvc-srcset={`${method.src}-wvc-srcset`} data-wvc-sizes={`${method.src}-wvc-sizes`} className="max-h-full max-w-full object-contain opacity-60 hover:opacity-100 transition-opacity grayscale hover:grayscale-0" loading="lazy" />
                </div>)}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default font-semibold text-foreground uppercase tracking-wider text-xs">
              Connect With Us
            </h3>
            <ul className="flex flex-col gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <li key={social.id} data-index={i}>
                    <Link to={social.href} className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors text-xs group">
                      <div className="bg-primary p-1.5 rounded-md text-primary-foreground group-hover:scale-110 transition-transform shadow-md">
                        <Icon className="size-3.5" />
                      </div>
                      <span className="font-default">{social.label}</span>
                    </Link>
                  </li>;
            })}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default font-semibold text-foreground uppercase tracking-wider text-xs">
              Installer Resources
            </h3>
            <div className="flex gap-3 items-start">
              <div className="bg-card border border-border p-1.5 rounded-md shadow-md shrink-0">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_training_qr.png" alt="Training Portal QR" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_training_qr.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_training_qr.png-wvc-sizes" className="size-20 object-contain" loading="lazy" />
              </div>
              <div className="flex flex-col gap-2 justify-between h-20">
                <Link to="/InstallerOpportunityPage" className="block bg-primary text-primary-foreground rounded-lg px-3 py-1 shadow-md hover:bg-secondary transition-colors text-[10px] font-default font-semibold text-center">
                  BECOME INSTALLER
                </Link>
                <Link to="/ApplyNowPage" className="block bg-card border border-primary text-primary rounded-lg px-3 py-1 shadow-sm hover:bg-accent transition-colors text-[10px] font-default font-semibold text-center">
                  APPLY NOW
                </Link>
              </div>
            </div>
          </div>

        </div>

        <Separator className="mb-8 bg-border" />

        <div className="flex flex-col lg:flex-row justify-between items-center gap-6 text-[12px] text-muted-foreground font-default">
          <div className="flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
            <Link to="/HomePage" className="shrink-0">
              <WvcLogo className="h-8 w-auto opacity-100 transition-opacity" />
            </Link>
            <p>© {new Date().getFullYear()} ClifRock. All Rights Reserved. Engineered for Outdoor Living.</p>
          </div>
          
          <div className="flex flex-wrap justify-center lg:justify-end items-center gap-x-2 gap-y-1">
            <span className="mr-2">Service Areas:</span>
            {countries.map((country, i) => <React.Fragment key={country}>
                <span data-index={i}>
                  <Link to="#" className="hover:text-primary transition-colors">
                    {country}
                  </Link>
                </span>
                {i < countries.length - 1 && <span className="text-border mx-1">|</span>}
              </React.Fragment>)}
          </div>
        </div>
      </div>
    </footer>;
}